export default "__VITE_ASSET__CwjMFUrt__"